import { VehicleBuyInSignatureDevice } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_BUY_IN_SIGNATURE_DEVICE_OPTIONS = [
  { id: VehicleBuyInSignatureDevice.Customer, name: "fab:UseCustomerEmailAddress" },
  { id: VehicleBuyInSignatureDevice.Company, name: "fab:UseBranchDevice" },
];

export class VehicleBuyInSignatureDeviceFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "signatureDevice";
  readonly labelSingular = "fab:SignatureDevice";
  readonly labelPlural = "fab:SignatureDevice";
  readonly placeholder = "fab:SelectSignatureDevice";
  readonly searchPlaceholder = "fab:SearchSignatureDevice";
  readonly emptyText = "fab:NoSignatureDeviceFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return { options: VEHICLE_BUY_IN_SIGNATURE_DEVICE_OPTIONS, isLoading: false, error: null };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
